import useConfigurations from "./useConfigurations";

export default useConfigurations;
